// extracted by mini-css-extract-plugin
export var entityChip = "_sj-0";
export var entityChipMissing = "_sj-1";